import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import { FDBodyText, FDClickableText, FDStack } from '@facet-wealth/design';
import {
  ModelUpdateCard,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPortfolioUpdatesStepTemplate/ModelUpdateCard';
import { useRightColumnContext } from 'Context/RightColumnContext';
import { dataAttrs, testAttr } from 'Helpers/Testing';

export const ScenarioSelectionRedefinedPortfolioUpdatesContent = ({
  resource,
}) => {
  const { loadRightColumnCollectionLink } = useRightColumnContext();
  return (
    <FDStack direction={'column'} alignItems={'center'} spacing={3} width={'100%'}>
      {resource.withRelationship(fr.relationships.justAskMyPlanner.name,
        (rel) => (
          <FDBodyText value={<>Any questions?{' '}
            <FDClickableText
              appearance="standalone"
              label={rel.meta('prompt')}
              onClick={() => loadRightColumnCollectionLink(rel.link('related'))}
            /></>}
          />
        ),
        () => null)}
      {resource.attr('modelUpdates').resources().list().map((modelUpdateResource, i) => (
        <ModelUpdateCard key={modelUpdateResource.id()} modelUpdateResource={modelUpdateResource} dataAttrs={{ ...dataAttrs('model-update-card', resource, { [testAttr.dataIndex]: i }) }} />
      ))}
    </FDStack>
  );
};

ScenarioSelectionRedefinedPortfolioUpdatesContent.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
